import { AButtonProps } from '../components/AButton';

const variantMap: Record<string, AButtonProps['variant']> = {
  outline: 'neutral-outline',
  solid: 'primary',
  link: 'link',
};

export const getButtonVariant = (variant?: string) => (variant ? variantMap[variant] : undefined);
